module.exports = __webpack_public_path__ + "static/assets/b70b0e93b0311ee07e6f91ec733f42bd.png";